import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";

import vuetify from "./plugins/vuetify";

import "@/styles/main.scss";

import CheckUserRolesMixin from "@/mixins/CheckUserRolesMixin";

Vue.config.productionTip = false;

Vue.mixin(CheckUserRolesMixin);

import setup from "./setupAuth";
setup().then(() => {
  new Vue({
    vuetify,
    router,
    render: h => h(App),
    data: () => {
      return { user: null as any, title: null as any };
    }
  }).$mount("#app");
});
